import { render, staticRenderFns } from "./integration-form.vue?vue&type=template&id=f5030538&"
import script from "./integration-form.vue?vue&type=script&lang=js&"
export * from "./integration-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports